module.exports = __webpack_public_path__ + "media/images/check_white-a317fd62.png";